import React, { useRef } from "react";
import Navbar from "../components/common/navbar";
import CategoryList from "../components/home/categoryList";
import ExtraAd from "../components/home/extraAd";
import ProductList from "../components/home/productList";
import AdvertiseProduct from "../components/home/advertiseProduct";
import Footer from "../components/common/footer";

const Home = () => {
  const categoryListRef = useRef(null);
  const footerRef = useRef(null);

  const handleCategoryClick = () => {
    categoryListRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleContactClick = () => {
    footerRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div>
        <Navbar onCategoryClick={handleCategoryClick} onContactClick={handleContactClick} />
      </div>
      <AdvertiseProduct />
      <div className="md:m-20">
        <div ref={categoryListRef}>
          <CategoryList />
        </div>
        <ExtraAd />
        <ProductList />
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
